import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type DcrModalState } from './dcrModal.types';

export const useDcrModalStore = create<DcrModalState>()(
	devtools(set => ({
		entityType: null,
		isOpen: false,
		isLoading: false,
		mountKey: 0,

		open: entityType =>
			set(({ mountKey }) => ({
				entityType,
				isOpen: true,
				isLoading: true,
				mountKey: mountKey + 1
			})),
		close: () => set({ isOpen: false }),
		exited: () => set({ entityType: null }),
		setLoaded: () => set({ isLoading: false })
	}))
);
